enum ExtensionTypeEnum {
    GracePeriod = 'GRACE_PERIOD',
    Renewal = 'RENEWAL',
}

export default ExtensionTypeEnum;
